import { render } from "./VisitorRegister.vue?vue&type=template&id=3b4701f9"
import script from "./VisitorRegister.vue?vue&type=script&lang=js"
export * from "./VisitorRegister.vue?vue&type=script&lang=js"

import "./VisitorRegister.vue?vue&type=style&index=0&id=3b4701f9&lang=css"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__